import { styled } from '@mui/material/styles';
import { Message } from '../../UI/Message/Message';

/**
 * Message wrapper with shared form/summary styles. Use for FormMessage and SummaryMessage.
 */
export const BaseFormMessage = styled(Message, {
	label: 'BaseFormMessage',
})({
	gridTemplateColumns: '0 1fr 0',
	'& .Message-balloon': {
		width: '100%',
		justifySelf: 'stretch',
		borderRadius: '0.6em',
		boxSizing: 'border-box',
		padding: 0,
	},
	'& .form__label, & .label': {
		color: 'var(--message__form__element__label_color)',
	},
	'& .form__help': {
		color: 'var(--message__form__help_color)',
		fontWeight: 'bold',
	},
	'& .form__required': {
		color: 'var(--message__form__required_color)',
		fontWeight: 'bold',
	},
	'& .form__error': {
		color: 'var(--message__form__error_color)',
	},
	'& .input': {
		backgroundColor: 'var(--message__form__element_background)',
		color: 'var(--message__form__element_color)',
		borderColor: 'transparent',
		minHeight: '2.4em',
		borderRadius: '0.4em',
		padding: '0.4em',
		'&::placeholder': {
			color: 'var(--message__form__element__placeholder_color)',
		},
	},
	'& .input--datetime, & .input--date': {
		backgroundColor: 'var(--message__form__date_background)',
	},
	'& .chooser__item:not(.chooser__item--checked)': {
		color: 'var(--message__form__chooser__item_color)',
		background: 'var(--message__form__chooser__item_background)',
		'&:not(.chooser__item--disabled):hover': {
			background: 'var(--message__form__chooser__item--hover_background)',
			color: 'var(--message__form__chooser__item--hover_color)',
		},
	},
	'& .radio-list': {
		color: 'var(--message__form__radio-list__label_color)',
	},
	'& .rating--item svg': {
		fill: 'var(--message__form__rating__item_color)',
	},
	'& .rating--item.message--checked svg': {
		fill: 'var(--message__form__rating__item--checked_color)',
	},
	'& .select__control': {
		backgroundColor: 'var(--message__form__select__control_background)',
	},
	'& .select__option': {
		color: 'var(--message__form__select__option_color)',
		backgroundColor: 'var(--message__form__select__option_background)',
		'&:hover': {
			backgroundColor: 'var(--message__form__select__option--hover_background)',
			color: 'var(--message__form__select__option--hover_color)',
		},
	},
	'& .textarea--box': {
		color: 'var(--message__form__textarea_color)',
		backgroundColor: 'var(--message__form__textarea_background)',
		'&::placeholder': {
			color: 'var(--message__form__textarea__placeholder_color)',
		},
	},
	'& .checkbox': {
		'& .icon': {
			fill: 'var(--message__form__checkbox__icon_background)',
			stroke: 'var(--message__form__checkbox__icon_border)',
		},
		'&.message--checked .icon': {
			fill: 'var(--message__form__checkbox--checked__icon_background)',
			stroke: 'var(--message__form__checkbox--checked__icon_border)',
		},
	},
	'& .radio': {
		'& .icon:not(.icon--circle)': {
			fill: 'var(--message__form__radio-list__item__icon_background)',
			stroke: 'var(--message__form__radio-list__item__icon_border)',
		},
		'& .icon--circle': {
			background: 'var(--message__form__radio-list__item__icon_background)',
			borderColor: 'var(--message__form__radio-list__item__icon_border)',
		},
		'&.message--checked .icon:not(.icon--circle)': {
			fill: 'var(--message__form__radio-list__item--checked__icon_background)',
			stroke: 'var(--message__form__radio-list__item--checked__icon_border)',
		},
		'&.message--checked .icon--circle': {
			background:
				'var(--message__form__radio-list__item--checked__icon_background)',
			borderColor:
				'var(--message__form__radio-list__item--checked__icon_border)',
		},
	},
});
